import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPublicStays = loadable(() => import(/* webpackChunkName: "content/hotels" */ './PublicStaysApp'), 'PublicStaysApp');
